import { animate, state, style, transition, trigger } from '@angular/animations';

export const SCROLLFOLDPERSON = trigger('personScrollAnimation', [
  state('open', style({ 'box-shadow': '0 0 0px 0px rgba(0, 0, 0, 0.2)' })),
  state('closed', style({ 'box-shadow': '0 0 3px 2px rgba(0, 0, 0, 0.2)' })),
  transition('open <=> closed', [animate('.2s ease-in-out')])
]);
